export default __webpack_public_path__ + "img/publication/publication3_src.jpg";